interface ToolbarProps {
  onCheckWord: () => void
  onCheckAll: () => void
  onRevealWord: () => void
  onClear: () => void
  onNewPuzzle?: () => void
}

export function Toolbar({ onCheckWord, onCheckAll, onRevealWord, onClear, onNewPuzzle }: ToolbarProps) {
  return (
    <div className="toolbar">
      <button className="toolbar-btn" onClick={onCheckWord}>Check Word</button>
      <button className="toolbar-btn" onClick={onCheckAll}>Check All</button>
      <button className="toolbar-btn" onClick={onRevealWord}>Reveal Word</button>
      <button className="toolbar-btn toolbar-btn--danger" onClick={onClear}>Clear Word</button>
      {onNewPuzzle && <button className="toolbar-btn toolbar-btn--new" onClick={onNewPuzzle}>New Puzzle</button>}
    </div>
  )
}
